import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDevices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/devices', {
            params: queryParams
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            console.error('Error fetching devices:', error);
            reject(error);
          });
      });
    },
    fetchDevice(ctx, {
      id,
      dataKey
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/devices/${id}`, {
            params: {
              dataKey,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDevice(ctx, device) {
      return new Promise((resolve, reject) => {
        axios
          .post('/devices', device)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateDevice(ctx, device) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/devices/${device.id}`, device)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteDevice(ctx, {
      id
    }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/devices/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDevicesBySite(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/devices/by-site', {
            params: queryParams
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCloudDevices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/cloud-connections/azure-devices', {
            params: queryParams
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchExportDevices() {
      return new Promise((resolve, reject) => {
        axios
          .get('/devices/export')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchGetLastIoTDataByCloudId(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/iot-data/last', {
            params: queryParams
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchIotDataChart(ctx, {
      cloudId,
      dataKey,
      startDate,
      endDate,
      rangeType,
      sensorType,
      onValue,
      onColor,
      offValue,
      offColor,
      listValues,
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/iot-data/chart/${cloudId}`, {
            params: {
              dataKey,
              startDate,
              endDate,
              rangeType,
              sensorType,
              onValue,
              onColor,
              offValue,
              offColor,
              listValues,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLastIotData(ctx, {
      cloudId,
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/iot-data/last', {
            params: {
              cloudId,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
